'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Failure = require('./Failure');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Failure).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Failure/index.js
// module id = 1182
// module chunks = 1